// D2Snap Configuration
export const uniqueIDAttribute = "data-uid";
